const dotCommon = {
  data: {
    icon: "/imgs/icons/asset/dot.svg",
    about:
      "Polkadot unites the world's innovators and changemakers, building and using the most transformative apps and blockchains.",
    links: [
      {
        name: "website",
        url: "https://polkadot.network/",
      },
      {
        name: "twitter",
        url: "https://twitter.com/Polkadot",
        icon: "/imgs/icons/link-x.svg",
      },
      {
        name: "reddit",
        url: "https://www.reddit.com/r/polkadot",
      },
      {
        name: "discord",
        url: "https://dot.li/discord",
      },
      {
        name: "Github",
        url: "https://github.com/paritytech/polkadot-sdk",
        icon: "/imgs/icons/link-github.svg",
        darkIcon: "/imgs/icons/link-github-dark.svg",
      },
      {
        name: "element",
        url: "https://matrix.to/#/#Polkadot-Direction:parity.io",
      },
    ],
  },
};

export default dotCommon;
